export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70f9c22661ec47be0956d3e08e65755d4884ad8b01&name=pushAdClickData!'